import type { FunctionComponent } from 'react';

import { AssistantBubble } from '~/ui/domain/chat/AssistantBubble';

import type { TextBlock } from '../../../data-contract/chat';
import { containsMarkdownTable } from '../../markdown-detection';
import { serializeRichTextToMarkdown } from '../../markdown-mentions';
import { useChatStore } from '../../stores/chat-open-store';
import { MentionMarkdown } from '../components/MentionMarkdown';
import type { BlockRenderer } from '../types';

const TextBlockBubble: FunctionComponent<{ readonly block: TextBlock }> = ({ block }) => {
    const { markdown, mentions } = serializeRichTextToMarkdown(block.content);
    const isMarkdownTableWide = useChatStore((state) => state.isMarkdownTableWide);
    const fullWidth = isMarkdownTableWide && containsMarkdownTable(markdown);

    return (
        <AssistantBubble>
            <AssistantBubble.Text fullWidth={fullWidth}>
                <MentionMarkdown markdown={markdown} mentions={mentions} />
            </AssistantBubble.Text>
        </AssistantBubble>
    );
};

export const textBlockRenderer: BlockRenderer<TextBlock> = {
    isAnswered: () => true,
    renderInline: (block) => <TextBlockBubble block={block} />,
    type: 'text',
};
